import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../Hooks/useAuth";
import { resolveLandingPath } from "../utils/landing";
import logger from "../utils/logger";

const Page404 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { auth } = useAuth();
  // Oturum açıksa doğrudan yetkili ilk sayfaya git. Önceden buton "/" ye
  // gidiyordu; LoginPage açık oturumu görüp resolveLandingPath ile tekrar
  // yönlendiriyordu — kullanıcıya sayfa "yerinde yenileniyor" gibi görünüyor,
  // yönlendirme hedefi de yine eşleşmezse 404'e geri düşülüyordu.
  const isLoggedIn = Boolean(auth?.accessToken);
  const landing = isLoggedIn ? resolveLandingPath(auth) : "/";
  // Hedef zaten bulunduğumuz sayfaysa navigate hiçbir şey yapmaz ve kullanıcı
  // "sayfa yerinde yenilendi" hissi alır. Profil'e düşeriz; oradaysak son çare
  // login (Profil de reddedilebiliyor — panele ait olmayan rol vakası).
  const SAFE_PATH = "/Anasayfa/Profil";
  const fallback = location.pathname === SAFE_PATH ? "/" : SAFE_PATH;
  const target =
    isLoggedIn && landing === location.pathname ? fallback : landing;
  const button =
    "items-center gap-2 text-white active:text-white hover:text-main flex bg-main rounded-md px-4 py-2 active:bg-main hover:bg-white mt-8 border border-main hover:border-main";

  useEffect(() => {
    logger.warn("[Page404] eşleşmeyen path:", location.pathname, {
      hash: window.location.hash,
      isLoggedIn,
      target,
    });
  }, [location.pathname, isLoggedIn, target]);

  return (
    <div>
      <div className=" fixed left-1/2 -translate-y-1/2 top-1/2 -translate-x-1/2 flex flex-col items-center">
        <div className=" text-[24rem] -tracking-wides font-Bold text-main">
          404
        </div>
        <div className=" text-5xl text-main">
          Üzgünüz sayfa yüklenirken bir sorunla karşılaştık...
        </div>
        <button
          type="button"
          className={button}
          onClick={() => navigate(target, { replace: true })}
        >
          {isLoggedIn ? "Ana Sayfaya Dön" : "Girişe Dön"}
        </button>
      </div>
    </div>
  );
};

export default Page404;
